import { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { Skeleton } from '@/components/ui/Skeleton';

export function SuperAdminRoute() {
  const { user } = useAuthStore();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const hydrationBuffer = setTimeout(() => setIsReady(true), 300);
    return () => clearTimeout(hydrationBuffer);
  }, []);

  if (!isReady) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Skeleton className="w-64 h-8" />
      </div>
    );
  }

  if (user?.role !== 'super_admin') {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}
